import { render } from "./downloadpdfpage.vue?vue&type=template&id=5cbb779e&scoped=true"
import script from "./downloadpdfpage.vue?vue&type=script&lang=js"
export * from "./downloadpdfpage.vue?vue&type=script&lang=js"

import "./downloadpdfpage.vue?vue&type=style&index=0&id=5cbb779e&scoped=true&lang=css"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbb779e"]])

export default __exports__